import Body from '../components/Body';

const Home = ({id}) => {
 
  return <Body id={id}/>;
};

export default Home;
